<div class="pt-2 pl-4 w-full">
  <p-checkbox [id]="'pdCheckbox_'+descriptorCategory().uniqueId+'_'+projectDescriptor.uniqueId" [inputId]="'pdCheckbox_'+descriptorCategory().uniqueId+'_'+projectDescriptor.uniqueId" (ngModelChange)="holder.value = $event.toString()" [ngModel]="holder.value == 'true'" binary="true" />
  <label [for]="'pdCheckbox_'+descriptorCategory().uniqueId+'_'+projectDescriptor.uniqueId"> {{projectDescriptor.label}} @if (projectDescriptor.help) {
    <i class="pi pi-question-circle" [pTooltip]="projectDescriptor.help" style="font-size: 1rem"></i>
  }</label>
</div>
